export enum StoreKey {
  company = 'current-company',
  themeName = 'theme-name',
  language = 'language',
  languagesList = 'languages',
  apiToken = 'token',
  Refresh = 'RefreshToken'
}
